import ModelEntityContextProvider from 'Utils/modelEntity/context';
import MainContentWidthContextProvider from 'Utils/realDom/context';
import TagsPanelControlsContextProvider from 'Utils/tags/TagsPanelControlsContext';
import CombineComponents from 'Widgets/CombineComponents/CombineComponents';
const providers = [
    TagsPanelControlsContextProvider,
    ModelEntityContextProvider,
    MainContentWidthContextProvider
];
const AppContextProvider = CombineComponents(providers);
export default AppContextProvider;
